module.exports = __webpack_public_path__ + "img/bag-small.025d06f3.svg";